<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">

    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? $t('AddNew') : "Room" }} Details</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>

    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">

      <div class="p-6">

       <vs-input :label="$t('ClassRoomName')" v-model="model.ClassRoomName" class="mt-5 w-full" name="ClassRoomName" :disabled="true" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('ClassRoomName')">{{ errors.first('ClassRoomName') }}</span>
        <vs-input :label="$t('CourseName')" v-model="model.CourseName" class="mt-5 w-full" name="CourseName" :disabled="true" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('CourseName')">{{ errors.first('CourseName') }}</span>

        <vs-input :label="$t('ClassNo')" v-model="model.ClassNo" class="mt-5 w-full" name="classNo" :disabled="true" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('classNo')">{{ errors.first('classNo') }}</span>

        <!-- start date -->
        <div class="spacer"></div>
        <label for="startDate" class="vs-input--label">{{$t('StartDate')}}</label>
        <datepicker :format="format" :placeholder="$t('StartDate')" v-model="model.StartDate" input-class="mt-5 w-full" name="startDate" v-validate="'required'" :disabled="true"></datepicker>        
        <span class="text-danger text-sm" v-show="errors.has('startDate')">{{ errors.first('startDate') }}</span>

        <!-- End date -->
         <div class="spacer"></div>
        <label for="startDate" class="vs-input--label">{{$t('EndDate')}}</label>
        <datepicker :format="format" :placeholder="$t('EndDate')" v-model="model.EndDate" class="mt-5 w-full" name="endDate" v-validate="'required'" :disabled="true"></datepicker>        
        <span class="text-danger text-sm" v-show="errors.has('endDate')">{{ errors.first('endDate') }}</span>

   <div>
<br/>
<vs-table ref="table"   class="mr-5 ml-5" pagination :max-items="itemsPerPage"  :data="model.CourseClassInstructors">
      <template slot="thead">
        <vs-th sort-key="Name">{{$t('Instructor')}}</vs-th>
         <vs-th sort-key="Name">{{$t('Module')}}</vs-th>
      </template>
        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.Instructor.Name }}</p>
              </vs-td>
                 <vs-td>
                <p class="product-name font-medium truncate">{{ tr.CourseModule.Name }}</p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
   </div>
  
      </div>
    </VuePerfectScrollbar>

  
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select';
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },

  watch: {
    isSidebarActive(val) { 
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      } else {
        debugger;
        this.model=this.data;
        let { ID, CourseName, ClassRoomName, StartDate, EndDate, ClassNo,CourseClassInstructors} = JSON.parse( 
          JSON.stringify(this.data)
        );        
        this.$store.commit("courseList/SET_CourseModule", []);
        this.$store.commit("courseList/SET_CourseInstructor", []);
        this.$store.commit("classRoomList/SET_ClassRooms", []);
        
        this.CourseClassInstructors={};
      debugger
        this.ID = ID;      
        this.CourseID= CourseID==undefined?"":CourseID;
        this.ClassRoomName = ClassRoomName == undefined?"":ClassRoomName;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.RegistrationDateDue = RegistrationDateDue;
        this.ClassNo= ClassNo;
      
        this.CourseClassInstructors=CourseClassInstructors==undefined?[]:CourseClassInstructors;
        //  this.$store.commit("annualPlanList/SET_AnnualPlanInstructor",  this.AnnualPlanInstructors);
        //  this.AnnualPlanInstructor.CourseModules=[];
         //if ClassNo not found Generate One
        //  if( this.ClassNo==undefined)
        //  {
        //    debugger;
        //      this.$store.dispatch("annualPlanList/GetClassNoCode").then(res=>{
        //       console.log(res);
        //          this.ClassNo=res.data;
        //     }).catch(err => {
        //       console.error(err);
        //     });
        //  }
      //  if( this.CourseID!=null)
      //  {
      //    this.GetInstructorByCourseID(this.CourseID);
      //    this.GetCourseModulesByCourseID(this.CourseID);
      //    this.GetClassRoomsValidToCourseByCourseID(this.CourseID);
      //  }
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.ID, this.Name, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },

  data() {
    return {
      model:{},
      itemsPerPage:5,
      ID: null,
      CourseName: '',
      CourseClassInstructors:[],
     
      CourseClassInstructors:{},
      ClassRoomName: '',
      StartDate : null,
      EndDate : null,
      ClassNo: "",
      format:"dd-MM-yyyy",
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },

  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
   
  },

  methods: {
    initValues() {
      if (this.data.ID) return;
      this.ID = null;      
      this.CourseName= "";
      this.ClassRoomName = "";
      this.StartDate = null;
      this.EndDate = null;
      this.ClassNo= "";
       
    },
 

    

    
  

   
  },
  created(){
    
  },

  components: {
    VuePerfectScrollbar,
    Datepicker,
    vSelect
  }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}

.spacer{
    clear: both;
    height: 10px;
}
</style>
